import React, { useMemo, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import Cookies from "js-cookie";
import { Alert, IconButton, InputAdornment } from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const ChangePasswordModal = ({
  open,
  onClose,
  onSubmit,
  loading,
  server,
  user,
}) => {
  const [showActualPassword, setShowActualPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

  const isMed = useMemo(() => {
    return user === "05273422000154";
  }, [user]);

  const handleSubmit = (event) => {
    if (isMed) {
      return onSubmit({
        success: false,
        message: "Não é possível alterar a senha para este usuário.",
      });
    }

    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const senha_atual = data.get("senha_atual");
    const nova_senha = data.get("nova_senha");
    const repita_senha = data.get("repita_senha");

    if (nova_senha !== repita_senha) {
      return onSubmit({
        success: false,
        message: "As senhas estão diferentes.",
      });
    }

    if (nova_senha.length < 8) {
      return onSubmit({
        success: false,
        message: "A senha deve conter 8 ou mais caracteres.",
      });
    }

    fetch(`${server}esqueci_senha`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("bearer"),
      },
      body: JSON.stringify({
        jsonid: localStorage.getItem("token"),
        senha_antiga: senha_atual,
        senha_nova: nova_senha,
        cnpj: user,
      }),
    })
      .then((res) => res.text())
      .then((json) => {
        if (json === "{}") {
          onSubmit({
            success: false,
            message: "A senha atual está incorreta.",
          });
        } else {
          onSubmit({
            success: true,
            message: "A senha foi alterada.",
          });
          onClose();
        }
      })
      .catch((err) => console.error("error:" + err));
  };

  return (
    <Dialog
      component="form"
      onSubmit={handleSubmit}
      open={open}
      onClose={onClose}
    >
      <DialogTitle>Alterar senha</DialogTitle>
      <DialogContent>
        <TextField
          margin="normal"
          required
          fullWidth
          name="senha_atual"
          label="Senha atual"
          type={showActualPassword ? "text" : "password"}
          id="senha_atual"
          autoComplete="current-password"
          disabled={isMed}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowActualPassword(!showActualPassword)}
                  edge="end"
                  disabled={isMed}
                >
                  {showActualPassword ? (
                    <VisibilityOffIcon />
                  ) : (
                    <RemoveRedEyeIcon />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="nova_senha"
          label="Nova senha"
          type={showNewPassword ? "text" : "password"}
          id="nova_senha"
          autoComplete="current-password"
          disabled={isMed}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  edge="end"
                  disabled={isMed}
                >
                  {showNewPassword ? (
                    <VisibilityOffIcon />
                  ) : (
                    <RemoveRedEyeIcon />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="repita_senha"
          label="Repita a nova senha"
          type={showConfirmNewPassword ? "text" : "password"}
          id="repita_senha"
          autoComplete="current-password"
          disabled={isMed}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() =>
                    setShowConfirmNewPassword(!showConfirmNewPassword)
                  }
                  edge="end"
                  disabled={isMed}
                >
                  {showConfirmNewPassword ? (
                    <VisibilityOffIcon />
                  ) : (
                    <RemoveRedEyeIcon />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </DialogContent>

      {isMed && (
        <Alert severity="error">
          Não é possível alterar a senha para este usuário.
        </Alert>
      )}

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <LoadingButton
          type="submit"
          variant="contained"
          loading={loading}
          disabled={isMed}
        >
          Alterar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordModal;
